import { render, staticRenderFns } from "./PlatformIntro.vue?vue&type=template&id=68e74f5d&scoped=true&"
import script from "./PlatformIntro.vue?vue&type=script&lang=js&"
export * from "./PlatformIntro.vue?vue&type=script&lang=js&"
import style0 from "./PlatformIntro.vue?vue&type=style&index=0&id=68e74f5d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e74f5d",
  null
  
)

export default component.exports